<div *ngIf="isPWAMobile; then pwaMobileTemplate; else browserTemplate"></div>
 <!-- TODO: move to a new component for invision-ux -->
<ng-template #browserTemplate>
	 <cv-invision-header [toggleUser]="toggleUser">
  </cv-invision-header>
</ng-template>
 
 <!-- PWA Header -->
<ng-template #pwaMobileTemplate>  
  <cv-pwa-header  [toggleUser]="toggleUser" [profile]="profile">
	<ng-content></ng-content>
  </cv-pwa-header>
</ng-template>

<cv-toaster></cv-toaster>
<cv-release-notes
	*ngIf="releasesNotes.open"
	(closeDialog)="releasesNotes.open = false"
>
</cv-release-notes>
